import { render, staticRenderFns } from "./PreviewSchoolTopbarSection.vue?vue&type=template&id=29a45a6e&"
import script from "./PreviewSchoolTopbarSection.vue?vue&type=script&lang=js&"
export * from "./PreviewSchoolTopbarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports